/**
 * Client Countdown Sticky Behavior
 * Positioned below header when both are sticky
 */

(function() {
  // Initialize sticky behavior for countdown sections
  function initCountdownSticky() {
    const countdownSections = document.querySelectorAll('.m-countdown-sticky-enabled[data-sticky="true"]');
    
    countdownSections.forEach(section => {
      const sectionInitialTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      let lastScrollY = 0;
      
      function updateStickyPosition() {
        const zIndex = section.dataset.stickyZIndex || 100;
        section.style.setProperty('--sticky-z-index', zIndex);
      }
      
      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        const threshold = 50;
        
        // If we haven't scrolled past the section, remove all classes
        if (currentScrollY <= sectionInitialTop - threshold) {
          section.classList.remove('scroll-up', 'scroll-down', 'stuck');
          return;
        }
        
        // Add stuck class when scrolled past section
        section.classList.add('stuck');
        
        // Handle scroll direction for show/hide
        if (currentScrollY > lastScrollY) {
          // Scrolling down - show the bar
          section.classList.remove('scroll-up');
          section.classList.add('scroll-down');
        } else if (currentScrollY < lastScrollY) {
          // Scrolling up - hide the bar
          section.classList.remove('scroll-down');
          section.classList.add('scroll-up');
        }
        
        lastScrollY = currentScrollY;
      });
      
      // Initial position update
      updateStickyPosition();
      
      // Update on resize
      window.addEventListener('resize', updateStickyPosition);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdownSticky);
  } else {
    initCountdownSticky();
  }
})();
